export enum ProgressType {
  CIRCLE = 'CIRCLE',
  BAR = 'BAR',
}
